import { useEffect, useState } from "react";
import { navItems } from "../data";
import { normalizePath } from "../router";
import Link from "./Link";

export default function Navbar({ currentPath }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const update = () => setScrolled(window.scrollY > 36);
    update();
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [currentPath]);

  return (
    <nav className={`navbar ${scrolled || menuOpen || currentPath !== "/" ? "scrolled" : ""}`}>
      <div className="nav-inner">
        <Link to="/" className="logo" aria-label="Orchid Salon home">
          <span className="logo-symbol">*</span>
          <span className="logo-text">Orchid<em> Salon</em></span>
        </Link>

        <button
          className={`hamburger ${menuOpen ? "open" : ""}`}
          type="button"
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span />
          <span />
          <span />
        </button>

        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
          {navItems.map((item) => {
            const active = normalizePath(currentPath) === item.path;
            return (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`${item.cta ? "nav-cta" : ""} ${active ? "active" : ""}`}
                >
                  {item.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
}
